import { render } from "./EventSettings.vue?vue&type=template&id=5a22b887&scoped=true"
import script from "./EventSettings.vue?vue&type=script&lang=js"
export * from "./EventSettings.vue?vue&type=script&lang=js"

import "./EventSettings.vue?vue&type=style&index=0&id=5a22b887&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a22b887"]])

export default __exports__